import { IImageVariants, ITypeImageVariant } from 'services/shop/interfaces';

export function getImage(
	imageVariants: IImageVariants,
	size: ITypeImageVariant
) {
	const defaultImg = '/assets/no-image.png';
	if (!imageVariants) {
		return defaultImg;
	}
	return imageVariants[size] || defaultImg;
}
